'use client';

import { useEffect } from 'react';

import { useCustomerAutoshipSubscriptions } from '@libs/common-next';
import { SetUpAutoshipOptions } from '@libs/shared-ui';

import { register, setValue, usePurchaseFormWatch } from '@/entities/purchase-form';

import { getAutoshipLabel } from '../lib';
import { ImmediateDeliveryTitle } from './ImmediateDeliveryTitle';

export const Options = () => {
    const { autoshipData } = useCustomerAutoshipSubscriptions();
    const nextSubscriptionDate = autoshipData?.data?.nextSubscriptionDate;
    const subscriptionType = usePurchaseFormWatch('subscriptionType');
    const autoshipFrequency = usePurchaseFormWatch('autoshipFrequency');
    const isOneTimeFrequency = autoshipFrequency === 'one_time';

    useEffect(() => {
        if (isOneTimeFrequency) {
            setValue('subscriptionType', 'existing');
        }
    }, [isOneTimeFrequency]);

    return (
        <SetUpAutoshipOptions
            subscriptionType={subscriptionType}
            immediateTitle={<ImmediateDeliveryTitle />}
            nextOrderLabel={getAutoshipLabel(nextSubscriptionDate)}
            isImmediateDisabled={isOneTimeFrequency}
            inputProps={register('subscriptionType')}
        />
    );
};
